<template>
  <div class="predefine" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div class="predefine-card" >
          <div v-for="item in pre_defined_items">

            <v-row class="checkbox-row">
              <v-col>
                <label>{{item.PredefinedTitle}}</label>

              </v-col>

              <v-col>
                <v-checkbox
                  v-model="checkbox_items"
                  :value="item.PreDefinedId"
                />
              </v-col>
            </v-row>

          </div>

          <div class="relative device-pass">
            <v-text-field
              :label="$t('summary')"
              v-model="summary"
              outlined
            ></v-text-field>
          </div>
        </div>
        <v-row>

          <v-btn color="primary" style="border-radius: 0px;" class="enter-btn"  v-on:click="send_predifined()">{{ $t('add_information') }}</v-btn>

        </v-row>
        <div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        checkbox_items: [],
        selected_currency: 0,
        price: '',
        summary: '',
        branch_id: 0,
        // device_serial_number: '',
        device_password: '',
        pre_defined_items: [],

        valid: true,
        not_register: false,
        user_registered: false,

      }
    },
watch: {

    },
mounted () {
      this.get_predifined()
    },
    methods: {

      get_predifined () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,

        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestQCItems', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.pre_defined_items = response.data.items.DbQCItems;
              self.summary = response.data.items.QcSummary;
              console.log("qc items",response.data.items.QCItems)
              response.data.items.QCItems.forEach(function (val) {
                self.checkbox_items.push(val.PreDefinedId)
              });
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      send_predifined () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          QcDesc: this.summary,
          ChkList: this.checkbox_items,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddRequestQC', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])

            if (response.data.error == 0) {
              self.$router.go(-1)
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
